<template>
  <transition name="slide-up">
    <div
      v-if="show"
      class="fixed left-1/2 -translate-x-1/2 bottom-6 z-[9999] w-full max-w-sm px-5 py-3 rounded-xl shadow-md border text-sm font-medium transition-all duration-300"
      :class="type === 'error' ? errorClass : successClass"
      role="status"
      aria-live="polite"
    >
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: "AppToast",
  props: {
    type: { type: String, default: "success" },
    message: { type: String, default: "" },
    show: { type: Boolean, default: false }
  },
  computed: {
    successClass() {
      // Verde pastel con detalles marrones suaves
      return 'bg-green-50 border-green-200 text-green-900';
    },
    errorClass() {
      // Crema claro con tonos tierra (marrón pastel)
      return 'bg-yellow-50 border-yellow-200 text-yellow-900';
    }
  }
}
</script>

<style>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease-in-out;
}
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
